import { action } from 'typesafe-actions'
import { AuthActionTypes } from './types'

export const createAccountRequest = () =>
  action(AuthActionTypes.CREATE_ACCOUNT_REQUEST)

export const createAccountSuccess = (registrationInfo: {
  firstName: string
  lastName: string
  mobileNumber?: string
  email: string
}) => action(AuthActionTypes.CREATE_ACCOUNT_SUCCESS, { registrationInfo })

export const createAccountFail = (message: string) =>
  action(AuthActionTypes.CREATE_ACCOUNT_FAIL, message)

export const loginRequest = () => action(AuthActionTypes.LOGIN_REQUEST)

export const loginSuccess = (data: {
  access_token: string
  identity: number
}) => action(AuthActionTypes.LOGIN_SUCCESS, data)

export const loginFail = (message: string) =>
  action(AuthActionTypes.LOGIN_FAIL, message)

export const getVerificationRequest = () =>
  action(AuthActionTypes.GET_VERIFICATION_REQUEST)

export const getVerificationSuccess = (data: { access_token: string }) =>
  action(AuthActionTypes.GET_VERIFICATION_SUCCESS, data)

export const getVerificationFail = (message: string) =>
  action(AuthActionTypes.GET_VERIFICATION_FAIL, message)

export const resendCodeRequest = () =>
  action(AuthActionTypes.RESEND_CODE_REQUEST)

export const resendCodeSuccess = (data: object) =>
  action(AuthActionTypes.RESEND_CODE_SUCCESS, data)

export const resendCodeFail = (message: string) =>
  action(AuthActionTypes.RESEND_CODE_FAIL, message)

export const fetchTermConditionsRequest = () =>
  action(AuthActionTypes.FETCH_TERMS_CONDITIONS_REQUEST)

export const fetchTermConditionsSuccess = (data: object) =>
  action(AuthActionTypes.FETCH_TERMS_CONDITIONS_SUCCESS, data)

export const fetchTermConditionsFail = (message: string) =>
  action(AuthActionTypes.FETCH_TERMS_CONDITIONS_FAIL, message)

export const resetPasswordRequest = () =>
  action(AuthActionTypes.RESET_PASSWORD_REQUEST)

export const resetPasswordSuccess = (data: object) =>
  action(AuthActionTypes.RESET_PASSWORD_SUCCESS, data)

export const resetPasswordFail = (message: string) =>
  action(AuthActionTypes.RESET_PASSWORD_FAIL, message)

export const changePasswordRequest = () =>
  action(AuthActionTypes.CHANGE_PASSWORD_REQUEST)

export const changePasswordSuccess = (data: object) =>
  action(AuthActionTypes.CHANGE_PASSWORD_SUCCESS, data)

export const changePasswordFail = (message: string) =>
  action(AuthActionTypes.CHANGE_PASSWORD_FAIL, message)

export const logout = () => action(AuthActionTypes.LOGOUT)

export const clearRegistrationData = () =>
  action(AuthActionTypes.CLEAR_REGISTRATION_DATA)

export const authenticated = () => action(AuthActionTypes.AUTHENTICATED)

export const admin = (isAdmin: boolean) =>
  action(AuthActionTypes.ADMIN, isAdmin)

// forgot password rest by email
export const restPasswordRequest = () =>
  // profileInfo: { profile: object }
  action(AuthActionTypes.REST_PASSWORD_REQUEST)
// , { profileInfo }

export const restPasswordSuccess = (profileInfo: { profile: object }) =>
  action(AuthActionTypes.REST_PASSWORD_SUCCESS, { profileInfo })

export const restPasswordFail = (message: string) =>
  action(AuthActionTypes.REST_PASSWORD_FAIL, message)

export const changePasswordByEmailRequest = () =>
  action(AuthActionTypes.CHANGE_PASSWORD_BY_EMAIL_REQUEST)

export const changePasswordByEmailSuccess = (profile: { profile: object }) =>
  action(AuthActionTypes.CHANGE_PASSWORD_BY_EMAIL_SUCCESS, { profile })

export const changePasswordByEmailFail = (message: string) =>
  action(AuthActionTypes.CHANGE_PASSWORD_BY_EMAIL_FAIL, message)

export const setEmilToStore = (email: string) =>
  action(AuthActionTypes.SET_EMAIL_TO_STORE, email)